import React from "react";
import { Grid } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
import MicIcon from "@mui/icons-material/Mic";
import CreateIcon from "@mui/icons-material/Create";
// import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

function UnpaidInvoicesNewList() {
  const navigate = useNavigate();

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // End

  return (
    <>
      <Grid container spacing={3} className="mainHeadingLine">
        <Grid item xs={12} md={12}>
          <div className="residentManagementTable">
            <div className="visitorListNewOut">
              <div className="visitorHead">Committee Management </div>
              <div className="visitorListNewInner">
                <div className="visitorSearch">
                  <div className="visitorSearchDiv">
                    <SearchIcon className="visitorSearchIco" />
                    <input type="text" placeholder="Search" />
                    <MicIcon className="visitorMicIco" />
                  </div>
                  <SortIcon
                    className="visitorFilterIco"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  />
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={handleClose}>Filter Item 1</MenuItem>
                    <MenuItem onClick={handleClose}>Filter Item 2</MenuItem>
                    <MenuItem onClick={handleClose}>Filter Item 3</MenuItem>
                  </Menu>
                </div>

                <div className="visitContDiv">
                  <div className="visitCont1 resideNewContOut">
                    <div className="visitContProf">
                      <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" alt="altimg"/>
                    </div>
                    <div className="visitContLeft">
                      <h3 className="visitContHed">Jerome Bell</h3>
                      <p className="visitContMob">(704) 555-0127</p>
                      <p className="visitContTime">sara.cruz@example.com</p>
                    </div>
                    <div className="visitBottCont">
                      <p>Wing/Flat Number</p>
                      <b>Wing A - 922</b>
                    </div>
                    <div className="visitBottCont">
                      <p>Bill Amount</p>
                      <b>1000</b>
                    </div>
                    <div className="visitBottCont">
                      <p>Bill Date</p>
                      <b>15-01-2023</b>
                    </div>
                    <div className="visitBottCont">
                      <p>Due Date</p>
                      <b>20-01-2023</b>
                    </div>
                    <div className="resideNewCont">
                      <CreateIcon className="editBt" />
                      {/* <DeleteIcon className="deleteBt" /> */}
                      <SearchIcon
                        className="editBt"
                        onClick={() => navigate("/InvoicePreview")}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default UnpaidInvoicesNewList;
